import React from 'react'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import { Dayjs } from 'dayjs'

import { lightTheme } from '~createTheme'

interface CustomDatePickerProps<TDate extends Dayjs>
  extends Omit<DatePickerProps<TDate>, 'open' | 'onOpen' | 'onClose'> {}

const CustomDatePicker = <TDate extends Dayjs>(
  props: CustomDatePickerProps<TDate>,
): React.ReactElement => {
  const [open, setOpen] = React.useState<boolean>(false)

  const handleClose = (): void => {
    const activeElement = document.activeElement
    const isInputElement = activeElement?.tagName === 'INPUT'

    if (!isInputElement) {
      setOpen(false)
    }
  }

  const placeHolder = props.disabled ? { placeholder: '' } : {}

  return (
    <DatePicker
      {...props}
      open={open}
      onClose={handleClose}
      slotProps={{
        ...props.slotProps,
        textField: {
          ...props.slotProps?.textField,
          onClick: () => {
            if (!props.disabled) setOpen(!open)
          },
          ...placeHolder,
          sx: {
            backgroundColor: props.disabled ? lightTheme.palette.action.disabledInput : 'white',
            '& .MuiInputBase-root': {
              cursor: 'pointer',
            },
            '& .MuiInputBase-input': {
              cursor: 'text',
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: 'black',
              '&::placeholder': {
                content: '""',
              },
            },
          },
        },
        openPickerButton: {
          ...props.slotProps?.openPickerButton,
          onClick: () => {
            if (!props.disabled) setOpen(!open)
          },
        },
        popper: {
          ...props.slotProps?.popper,
          sx: {
            zIndex: 1300,
          },
        },
      }}
    />
  )
}

export default CustomDatePicker
